// Rendu Markdown sécurisé pour les articles du journal.
// Utilise `marked` pour le parsing et `dompurify` pour la sanitization.
import { marked } from "marked";
import DOMPurify from "dompurify";

// Options marked : GFM (tables, autolinks), line breaks, en-tête simples
marked.setOptions({
    gfm: true,
    breaks: true,
    headerIds: false,
    mangle: false,
});

// Whitelist minimale — pas d'iframe, pas de script, pas d'attributs on*
const SANITIZE_CONFIG = {
    ALLOWED_TAGS: [
        "p", "br", "strong", "em", "u", "s", "code", "pre", "blockquote",
        "h2", "h3", "h4", "ul", "ol", "li", "a", "hr",
    ],
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
    ALLOW_DATA_ATTR: false,
};

export function renderMarkdown(md) {
    if (!md) return "";
    const html = marked.parse(md);
    return DOMPurify.sanitize(html, SANITIZE_CONFIG);
}
